module.exports = __webpack_public_path__ + "img/casino-micro.cb3c70f9.jpg";